<script>
import ConfirmModal from './hamburger-menu/ConfirmModal'
import SqlChosenControlButtons from '../form/controls/SqlChosenControlButtons.vue'
import ListHeaderMenu from './hamburger-menu/ListHeaderMenu.vue'
import QueueButtonGroup from './hamburger-menu/QueueButtonGroup'
import Limitation from './Limitation'
import ListButtonContainer from './ListButtonContainer'
import ListViewContainer from './list-views/ListViewContainer'
import Pagination from './Pagination'
import ProgressBar from '../ProgressBar'
import SavedSearchModal from './hamburger-menu/SavedSearchModal'
import SearchButton from './search/SearchButton'
import SearchControl from './search/SearchControl'
import ShowInListModal from './hamburger-menu/ShowInListModal'
import listRestMixin from '../../utils/mixin-list-rest'
import listCommonMixin from '../../utils/mixin-list-common'
import listStoreModule from '../../store/modules/list-new'
import coreMixin from '../../utils/mixin-core'
import pagination from '../../utils/mixin-pagination'
import localStore from '../../utils/mixin-local-store'
import store from '../../store'
import EventBus from '../../utils/event-bus'
import { resolveUrlParams, isObject } from '../../utils'
import { convertStringToStyleObject } from './lib/utils'
import { parseMultiColumnName } from '../../utils/list'
import {
  cloneDeep,
  concat,
  debounce,
  get,
  isEmpty,
  isNumber,
  isEqual,
  isArray,
  isFunction,
  map,
  mapValues,
  omit,
  pickBy,
  union,
} from 'lodash'
import {
  COLLAPSED_SETTINGS,
  DEFAULT_EDITABLE_LIST_EXTENDED_OPTIONS,
  DEFAULT_EXTENDED_OPTIONS,
  DEFAULT_LAYOUT,
  DEFAULT_LIST_VISIBILITY_OPTIONS,
  DEFAULT_ORDER,
  DEFAULT_PAGER,
  LIST_VIEW_MODES,
  READ_VIEW_EXTENDED_OPTIONS,
  SOURCE_TYPES,
  VIEW_MODE_CARD,
  VIEW_MODE_DETAIL,
  VIEW_MODE_GRID,
  ROW_STYLE_REGEXP,
  ROW_STYLE_MODEL_REGEXP,
  ROW_STYLE_ROW,
  ROW_STYLE_COLUMN,
  ROW_STYLE_CELL,
  PROP_ROW_KEY,
} from './lib/list-constants'
import { PANEL_TYPES } from '../layout-manager/gui-editor/options/schema'

export default {
  name: 'ListContainer',
  instanceStore: {
    name: 'listStore',
    module: listStoreModule,
  },
  mixins: [listRestMixin, localStore, pagination],
  components: {
    ConfirmModal,
    SqlChosenControlButtons,
    QueueButtonGroup,
    Limitation,
    ListButtonContainer,
    ListViewContainer,
    Pagination,
    ProgressBar,
    SavedSearchModal,
    SearchButton,
    SearchControl,
    ShowInListModal,
  },
  props: {
    isReadView: {
      type: Boolean,
      default: false,
    },
    mongoId: {
      type: String,
      default: '',
    },
    queryId: {
      type: String,
      default: '',
    },
    popupTitle: {
      type: String,
      default: '',
    },
    sqlName: {
      type: String,
      required: false,
    },
    languageLabel: {
      type: String,
      required: false,
      default: 'elem',
    },
    sqlFunction: {
      type: String,
      required: false,
    },
    lastModDate: {
      type: String,
      default: '',
    },
    transmittedGroupActions: {
      type: Array,
      default: () => [],
    },
    processActions: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    isVersionList: {
      type: Boolean,
      default: false,
    },
    isRelationshipList: {
      type: Boolean,
      default: false,
    },
    isSqlChosen: {
      type: Boolean,
      default: false,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    visibleOptions: {
      type: Object,
      default: () => ({}),
    },
    searchData: {
      type: Object,
      default: () => ({}),
    },
    hiddenSearchData: {
      type: Object,
      default: () => ({}),
    },
    controllerName: {
      type: String,
      default: () => {
        return window.CORE.requestController
      },
    },
    docMTNList: {
      type: Array,
      default: null,
    },
    mongoList: {
      type: Object,
      default: () => null,
    },
    detailview: {
      type: String,
      default: '',
    },
    order: {
      type: [Object, Array],
      default: () => [],
    },
    orders: {
      type: Array,
      default: () => [],
    },
    textLimit: {
      type: Number,
      default: null,
    },
    extraOptions: {
      type: Object,
      default: () => ({}),
    },
    mappingOptions: {
      type: Object,
      default: () => ({}),
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    panelId: {
      type: String,
    },
    defaultEmpty: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
    },
    isInDashboard: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSubDetailView: {
      type: Boolean,
      default: false,
    },
    eventSelectedRow: {
      type: Number,
      default: -1,
    },
    showExportButton: {
      type: Boolean,
      default: true,
    },
    infiniteScroll: {
      type: Boolean,
      default: false,
    },
    infiniteScrollOffset: {
      type: Number,
      default: 0,
    },
    subBlockUrl: {
      type: String,
      default: '',
    },
    customLayout: {
      type: String,
      default: '',
    },
    multiSelect: {
      type: Boolean,
      default: true,
    },
    expandedRowParams: {
      type: Object,
      default: () => ({}),
    },
    fieldName: {
      type: String,
    },
    processId: {
      type: String,
      default: '',
    },
    processData: {
      type: Object,
      default: () => ({}),
    },
    sqlExpandedLimit: {
      type: Number,
      default: 10,
    },
    sqlChosenShowListOnStart: {
      type: Boolean,
      default: false,
    },
    sqlChosenButtonProps: {
      type: Object,
      default: () => ({}),
    },
    rawSqlId: {
      type: String,
      default: '',
    },
    rawSqlNamespace: {
      type: String,
    },
    valueFromParam: {
      type: Boolean,
      default: true,
    },
    componentType: {
      type: String,
    },
    initCustomList: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      layout: DEFAULT_LAYOUT,
      isStoreReady: false,
      userId: get(window, 'CORE.params.ID_S_USER', null),
    }
  },
  computed: {
    listType() {
      return this.$get('listType')
    },
    isEditableList() {
      return this.listType === PANEL_TYPES.EDITABLE_LIST
    },
    id() {
      let id = !isEmpty(this.mongoList)
        ? get(this.mongoList, 'collection', '').toLowerCase()
        : this.mongoId || this.queryId || this.processId || this.rawSqlId || this.panelId || null
      return [SOURCE_TYPES.SQL_CHOSEN].includes(this.componentType) ? `${id}:${this.fieldName}` : id
    },
    actionsInlineVisible() {
      return this.visibilityState && this.visibilityState({ key: 'actionsInlineVisible' })
    },
    aggr() {
      return this.aggregations
        ? JSON.stringify(
            this.aggregations.reduce((accumulator, { column = '', aggr = 'Off' }) => {
              if (aggr !== 'Off') {
                accumulator.push({ column, aggr })
              }
              return accumulator
            }, [])
          )
        : []
    },
    aggregateColumn() {
      return this.$get('aggregateColumn')
    },
    aggregateRow: {
      get() {
        return this.$get('aggregateRow')
      },
      set(aggregateRow) {
        this.$dispatch('setAggregateRow', { aggregateRow })
      },
    },
    aggregations() {
      const aggregations = this.$get('aggregations')
      if (isFunction(aggregations)) return []
      return aggregations
    },
    availableInDetailView: {
      get() {
        return this.$get('availableInDetailView')
      },
      set(availableInDetailView) {
        this.$dispatch('setAvailableInDetailView', { availableInDetailView })
      },
    },
    availableInList: {
      get() {
        return this.$get('availableInList')
      },
      set(availableInList) {
        this.$dispatch('setAvailableInList', { availableInList })
      },
    },
    availableViews() {
      return pickBy(LIST_VIEW_MODES, (view) => this.extendedOptions.availableViews[view.name])
    },
    binds() {
      return this.rawSqlNamespace ? get(this.$store, `getters[${this.rawSqlNamespace}/binds]`) : {}
    },
    conditions() {
      return this.rawSqlNamespace ? get(this.$store, `getters[${this.rawSqlNamespace}/conditions]`, []) : []
    },
    columnOverrides() {
      return this.extendedOptions.columns
    },
    columns: {
      get() {
        const columns = this.$get('columns') || []
        if (isFunction(columns)) return []
        return columns
      },
      set(columns, oldColumns) {
        if (!isEqual(columns, oldColumns)) {
          this.$dispatch('setColumns', { columns })
        }
      },
    },
    currentParameters: {
      get() {
        return this.$get('currentParameters')
      },
      set(newValue) {
        this.$dispatch('setCurrentParameters', {
          currentParameters: newValue,
        })
      },
    },
    defaultAggregations() {
      let aggregations = {}
      if (this.summaryRowDefault) {
        Object.keys(this.aggregateColumn).forEach((column) => {
          aggregations[column] = {
            aggr: 'SUM',
            column,
          }
        })
      }
      if (this.columnOverrides) {
        this.columnOverrides.forEach((column) => {
          if (column.aggregation && column.aggregation !== 'Off') {
            aggregations[column.columnName] = {
              aggr: column.aggregation,
              column: column.columnName,
            }
          }
        })
      }
      return map(aggregations)
    },
    defaultShowInList: {
      get() {
        return this.$get('defaultShowInList')
      },
      set(showInList) {
        this.$dispatch('setDefaultShowInList', { showInList })
      },
    },
    defaultView() {
      return this.$get('defaultView')
    },
    expandedRows: {
      get() {
        return this.$get('expandedRows')
      },
      set(rows) {
        this.$dispatch('setExpandedRows', { rows })
      },
    },
    extendedOptions() {
      let options = Object.assign(cloneDeep(DEFAULT_EXTENDED_OPTIONS), this.extraOptions)
      if (this.isReadView) {
        options = Object.assign(options, READ_VIEW_EXTENDED_OPTIONS)
      }
      if (this.isEditableList) {
        options = Object.assign(cloneDeep(DEFAULT_EDITABLE_LIST_EXTENDED_OPTIONS), this.extraOptions)
      }
      return options
    },
    extendedVisibilityProps() {
      return this.$get('extendedVisibilityProps')
    },
    fetchingListData: {
      get() {
        return this.$get('fetchingListData')
      },
      set(fetchingListData) {
        this.$dispatch('setFetchingListData', { fetchingListData })
      },
    },
    filterId() {
      const searchParams = new URLSearchParams(window.location.search)
      return searchParams.get(`filter-${this.uniqueId}`)
    },
    getControllerName() {
      if (this.isInDashboard && !this.controllerName) {
        return
      }
      if (!this.controllerName && window.CORE && window.CORE.requestController && !this.isRelationshipList) {
        return window.CORE.requestController
      }
      return this.controllerName
    },
    groupActionsRunning: {
      get() {
        return this.$get('groupActionsRunning')
      },
      set(groupActionsRunning) {
        this.$dispatch('setGroupActionsRunning', { groupActionsRunning })
      },
    },
    hasPredefinedOrder() {
      return (
        !isEmpty(this.order) ||
        !isEmpty(this.orders) ||
        (this.hiddenSearchData && this.hiddenSearchData.hasOwnProperty('order'))
      )
    },
    hasSqlChosenValue() {
      return (
        (['object', 'string'].includes(typeof this.value) && !isEmpty(this.value)) ||
        (typeof this.value === 'number' && this.value > 0)
      )
    },
    hiddenSearch: {
      get() {
        return this.$get('hiddenSearch')
      },
      set(value) {
        this.$dispatch('setHiddenSearch', value)
      },
    },
    isDefaultEmpty() {
      return this.defaultEmpty && !this.selectedRow
    },
    isListExpanded: {
      get() {
        return this.visibilityState && this.visibilityState({ key: 'isExpanded' })
      },
      set(isListExpanded) {
        this.$dispatch('setVisibility', {
          key: 'isExpanded',
          value: isListExpanded,
        })
      },
    },
    isProcessList() {
      return !isEmpty(this.processData)
    },
    isSearchBarActive() {
      const searchParams = this.searchParams && isObject(this.searchParams) ? cloneDeep(this.searchParams) : {}
      delete searchParams.start
      return !(
        isEmpty(searchParams) &&
        this.selectedRowsFilter === 'normal' &&
        isEmpty(get(this.universalFilter, 'value', ''))
      )
    },
    listData: {
      get() {
        const listData = this.$get('listData') || []
        if (isFunction(listData)) return []
        return listData.map((row) => {
          this.checkUrlParamsForSubBlock(row)
          return row
        })
      },
      set(listData) {
        this.$dispatch('setListData', { listData })
      },
    },
    mainTable() {
      return (this.primaryKey && this.primaryKey.substring(3)) || ''
    },
    needButtonLists() {
      return this.viewMode !== 'gridView'
    },
    orderParams: {
      get() {
        if (isEmpty(this.orderState)) return []
        return map(this.orderState, (value, key) => {
          return { column: key, dir: value }
        })
      },
      set(newValue) {
        let value = {}
        newValue.forEach((order) => {
          value[order.column] = order.dir
        })
        this.$dispatch('setOrder', { value })
      },
    },
    orderState() {
      return this.$get('orderState')
    },
    paramsBase() {
      const params = {
        panelId: this.panelId,
        formId: this.mongoId,
        queryId: this.queryId,
        rawSqlId: this.rawSqlId,
        processId: this.processId,
        mongoList: this.mongoList && JSON.stringify(this.mongoList),
        controllerName: this.getControllerName,
        docMTNList: this.docMTNList ? JSON.stringify(this.docMTNList) : null,
        view: this.detailview,
        showDetails: this.showDetails,
        mappingOptions: JSON.stringify(this.mappingOptions),
        search: JSON.stringify(omit(this.searchParams, 'start')),
        fieldName: this.fieldName,
        sourceType: this.sourceType,
      }

      if (!this.panelId && this.extendedOptions) {
        params.options = JSON.stringify(this.extendedOptions)
      }

      return params
    },
    paramsFromProps() {
      return Object.assign({}, this.paramsBase, {
        textLimit: this.detailview === 'detail' ? 500 : this.textLimit,
        expandedRowParams: JSON.stringify(this.expandedRowParams),
      })
    },
    paramsFromStore() {
      return {
        columns: JSON.stringify(this.columnsToQuery),
        selectedRow: this.selectedRow,
        selectedRows: JSON.stringify(this.selectedRows),
        selectedRowsFilter: this.selectedRowsFilter,
        aggr: this.aggr,
        hiddenSearchData: JSON.stringify(this.hiddenSearch),
        search: omit(this.searchParams, 'start'),
        u: this.universalFilter,
        start: this.offset || 0,
        length: this.limit,
        order: JSON.stringify(this.orderParams),
      }
    },
    primaryKey: {
      get() {
        return this.$get('primaryKey')
      },
      set(primaryKey) {
        this.$dispatch('setPrimaryKey', { primaryKey })
      },
    },
    processActionsButtons: {
      get() {
        return this.$get('processActionsButtons')
      },
      set(processActionsButtons) {
        this.$dispatch('setProcessActionsButtons', { processActionsButtons })
      },
    },
    properties: {
      get() {
        return this.$get('properties')
      },
      set(value) {
        this.$dispatch('setListProperties', { value })
      },
    },
    recordsFiltered: {
      get() {
        return this.$get('recordsFiltered')
      },
      set(recordsFiltered) {
        this.$dispatch('setRecordsFiltered', { recordsFiltered })
      },
    },
    recordsTotal: {
      get() {
        return this.$get('recordsTotal')
      },
      set(recordsTotal) {
        this.$dispatch('setRecordsTotal', { recordsTotal })
      },
    },
    rowDetails: {
      get() {
        return this.$get('rowDetails')
      },
      set({ index, value }) {
        this.$dispatch('setRowDetails', { index, value })
      },
    },
    rowStyle() {
      return this.$get('rowStyle')
    },
    searchParams: {
      get() {
        return this.$get('searchParams')
      },
      set(params) {
        this.$dispatch('setSearchParams', { params })
      },
    },
    selectedGroupAction() {
      return this.$get('selectedGroupAction')
    },
    selectedRow: {
      get() {
        return this.$get('selectedRow')
      },
      set(value) {
        this.$dispatch('setSelectedRow', { value })
      },
    },
    selectedRows: {
      get() {
        return this.$get('selectedRows')
      },
      set(value) {
        this.$dispatch('setSelectedRows', { value })
      },
    },
    selectedRowsFilter: {
      get() {
        return this.$get('selectedRowsFilter')
      },
      set(selectedRowsFilter) {
        this.$dispatch('setSelectedRowsFilter', { selectedRowsFilter })
      },
    },
    showCollapsedActions() {
      return this.visibilityState && this.visibilityState({ key: 'showCollapsedActions' })
    },
    showInList: {
      get() {
        return this.$get('showInList')
      },
      set(showInList) {
        this.$dispatch('setShowInList', { showInList })
        this.localStore?.setItemValue('showInList', showInList)
      },
    },
    storageKeyBuilder() {
      const id = this.id
      const view = this.detailview || 'list'
      const requestRoute = get(window, 'CORE.requestRoute', '')
      let key = 'vue-smartTable-settings'
      if (id) key += `-${id}`
      if (view) key += `-${view}`
      if (requestRoute) key += `-${requestRoute}`
      if (this.uniqueId > -1) key += `-${this.uniqueId}`
      if (this.sqlName) key += `-${this.sqlName}`
      if (this.userId) key += `-${this.userId}`
      if (this.isSqlChosen) key += `-${this.fieldName}`
      this.$emit('storage-key', key)
      return key
    },
    summaryRowDefault() {
      return this.visibilityState && this.visibilityState({ key: 'summaryRowDefault' })
    },
    uniqueId() {
      return this.panelId ? get(this.panelId.match(/\d+$/), '0', 0) : this.mongoId || this.rawSqlId
    },
    universalFilter: {
      get() {
        return get(this.$get('universalFilter'), 'value')
      },
      set(value) {
        this.$dispatch('setUniversalFilter', { value })
      },
    },
    viewMode: {
      get() {
        return this.$get('viewMode')
      },
      set(mode) {
        if (get(this.availableViews, mode, false)) {
          this.setViewMode(mode)
        }
      },
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
    visibleKeys() {
      return this.listData.map((row) => row.ROW_KEY)
    },
    columnsToQuery() {
      let columnNames = []
      if (isEmpty(this.availableInList)) {
        columnNames = this.columns.map((column) => column.data)
      } else {
        columnNames = union(this.showInList, this.availableInDetailView)
      }
      const multiColumnNames = this.columns.filter((column) => column.data.match(/^MULTI_/))
      multiColumnNames.forEach((multi) => {
        const index = columnNames.indexOf(parseMultiColumnName(multi.data))
        columnNames[index] = multi.data
      })
      return columnNames
    },
    sourceType() {
      let sourceType = SOURCE_TYPES.FORM
      switch (this.componentType) {
        case PANEL_TYPES.MONGO_LIST:
          sourceType = SOURCE_TYPES.MONGO
          break
        case PANEL_TYPES.QUERY_LIST:
          sourceType = SOURCE_TYPES.QUERY
          break
        case PANEL_TYPES.TASK_LIST:
          sourceType = SOURCE_TYPES.TASK_LIST
          break
        case PANEL_TYPES.EDITABLE_LIST:
          sourceType = SOURCE_TYPES.EDITABLE_LIST
          break
        case PANEL_TYPES.FORM_DATA_VERSION:
          sourceType = SOURCE_TYPES.FORM_VERSION
          break
        default:
          if (this.isSqlChosen) sourceType = SOURCE_TYPES.SQL_CHOSEN
          break
      }
      return sourceType
    },
  },
  methods: {
    addRowToSelection(row) {
      if (row && Number(row) >= 0) {
        this.selectedRows = union(this.selectedRows, [Number(row)])
      }
    },
    /**
     * @description Decides to refresh the list or not
     * @param event
     */
    applyOrNot({ id, type = this.mongoList, idForm = null }) {
      if (idForm && idForm !== this.mongoId) return
      if (!idForm && id !== this.id) return
      this.refreshLocalStore()
      if (!this.extendedOptions.searchKeypress || this.isSqlChosen || type) this.fetchData(type)
    },
    resetOrder({ id }) {
      if (id !== this.id) return
      if (this.hasPredefinedOrder) {
        this.resolveOrderProps()
      } else {
        this.fetchData('order')
      }
    },
    checkUrlParamsForSubBlock(row) {
      if (this.rawSqlId) {
        row['ID_NAME'] = this.primaryKey
        row['ID_VALUE'] = row[this.primaryKey]
      }
      return row
    },
    async createLocalStorage() {
      this.$dispatch('setStorageKey', { value: this.storageKeyBuilder })
      this.createLocalStore()

      if (!this.localStoreContent) {
        this.showInList = this.defaultShowInList
        this.localStore.setStoreContent({})
      }
      this.restoreParameters()
    },
    /**
     * @description Fetches the action buttons for all visible instances
     */
    fetchButtonLists() {
      this.visibleKeys.forEach((id, index) => {
        this.fetchButtons(id, index)
      })
    },
    /**
     * @description Fetches the action buttons of a given instance
     * @param id
     * @param index
     * @returns {Promise<void>}
     */
    async fetchButtons(id, index) {
      const detailOption = { ...this.rowDetails[id] }
      if (detailOption.status === 'success') return
      const parameters = this.getButtonParameters(id, index)
      try {
        const buttonList = await this.getButtonList(parameters)
        let functions = get(buttonList, 'obj.data.functions', [])
        functions = functions.map((button) => {
          if (button.type === 'nodeProcess') {
            const hasNoApiBasePathInUrl = button.url.indexOf(window.CORE.apiBasePath) === -1
            if (hasNoApiBasePathInUrl) {
              button.url = `${window.CORE.apiBasePath}${button.url}`
            }
          }
          button.url = resolveUrlParams(button, this.$route)
          return button
        })
        // button overrides
        functions = this.resolveProcessButtonOverrides(functions)
        detailOption.status = 'success'

        const idName = this.primaryKey
        const detailViewOptions = Object.assign(
          {},
          {
            hiddenSearchData: { where: [{ key: idName, value: id }] },
            mongoList: this.mongoList,
            docMTNList: this.docMTNList,
            mongoId: this.mongoId,
            queryId: this.queryId,
            extraOptions: this.extendedOptions,
            panelId: this.panelId,
          }
        )
        Object.assign(detailOption, {
          options: { view: { properties: { ...detailViewOptions } } },
        })
        Object.assign(detailOption.options, { functions })
        this.rowDetails = Object.assign({}, this.rowDetails, {
          index: id,
          value: detailOption,
        })
      } catch (error) {
        detailOption.status = 'fail'
        detailOption.errorMessage =
          error.message && error.message.includes('Ldata is undefined')
            ? this.$i18n.t('data is undefined')
            : error.message
      }
    },
    isValidId(id) {
      return id && (id === this?.mongoId || id === this?.id || id === this?.panelId)
    },
    refreshListData(id) {
      if (this.isValidId(id)) {
        this.fetchData('', {}, true)
      }
    },
    /**
     * @description Fetching Listdata based on current search parameters
     * @param type
     * @param parameters
     * @param forced
     * @returns {Promise<void>}
     */
    fetchData: async function (type = 'default', parameters = {}, forced = false) {
      // if the new parameter is not pagination or infinitescroll, start results on first page
      if (this.isSearchBarActive && !this.infiniteScroll && !['scroll', 'pagination'].includes(type)) {
        this.offset = 0
      }

      parameters = Object.assign({}, this.paramsFromProps, this.paramsFromStore, parameters)

      if (!isEmpty(parameters.search)) this.searchParams = parameters.search
      if (this.rawSqlId) {
        parameters.bindValues = mapValues(this.binds, (bind) => get(bind, 'value') || null)
        parameters.conditions = this.conditions
      }
      // avoid void request
      if (isEmpty(JSON.parse(parameters.columns))) return
      this.addRowToSelection(this.selectedRow)
      this.addRowToSelection(this.eventSelectedRow)
      // don't create request if parameters have not changed
      if (isEqual(this.currentParameters, parameters) && !forced) return
      this.currentParameters = cloneDeep(parameters)
      this.fetchingListData = true
      // if defaultEmpty and no search active
      if (this.isDefaultEmpty && !this.isSearchBarActive) {
        this.listData = []
        this.$dispatch('setPager', { prop: 'total', value: 0 })
      } else {
        if (this.isProcessList) {
          const { recordsFiltered, recordsTotal, aggregateRow, data } = this.processData.list
          Object.assign(this, { recordsFiltered, recordsTotal, aggregateRow })
          if (this.infiniteScroll && type === 'scroll') {
            // Infinite scroll
            if (!isEmpty(data)) this.listData = concat(this.listData, data)
          } else {
            // Normal load
            this.listData = data || []
          }
          this.$dispatch('setPager', { prop: 'total', value: recordsTotal })
        } else {
          if (isNaN(parameters.start)) {
            delete parameters.start
          }
          const { body } = await this.getList(parameters)
          const { recordsFiltered, recordsTotal, aggregateRow, data } = body
          Object.assign(this, { recordsFiltered, recordsTotal, aggregateRow })
          if (this.infiniteScroll && type === 'scroll') {
            // Infinite scroll
            if (!isEmpty(data)) this.listData = concat(this.listData, data)
          } else {
            // Normal load
            this.listData = data || []
          }
          this.resolveRowStyles()
          this.$dispatch('setPager', { prop: 'total', value: recordsTotal })
        }
      }
      if (this.needButtonLists) this.fetchButtonLists()
      this.groupActionsRunning = false
      if (this.actionsInlineVisible) {
        const rowKey = get(this.listData, '[0].ROW_KEY')
        if (this.singleLineGrid && rowKey) {
          await this.fetchButtons(rowKey, 0)
        }
      }
      this.fetchingListData = false
    },
    getButtonParameters(id, index) {
      return Object.assign({}, this.paramsBase, {
        options: JSON.stringify(this.extendedOptions),
        primaryKey: id,
        table: this.mainTable,
        instance: JSON.stringify(this.listData[index]),
      })
    },
    async getSavedFilter() {
      const savedFilter = await this.$client.execute({
        operationId: 'SavedFilter_find',
        parameters: {
          filter: JSON.stringify({
            where: {
              and: [
                { or: [{ createUser: this.userId }, { isPublic: 'true' }] },
                { listId: `list-${this.mongoId || this.queryId}` },
                { id: this.filterId },
              ],
            },
          }),
        },
      })

      const parameters = get(savedFilter, 'obj.0.params', null)
      if (!parameters) this.deleteFilterParam()

      return parameters
    },
    deleteFilterParam() {
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.delete(`filter-${this.uniqueId}`)
      const newUrl = `${window.location.protocol}//${window.location.host}${
        window.location.pathname
      }?${searchParams.toString()}`
      window.history.pushState({ path: newUrl }, '', newUrl)
    },
    /**
     * @description Fetching parameters for the List
     * @returns {Promise<void>}
     */
    setup: async function () {
      // Get List setup
      let listSetup
      if (this.isProcessList) {
        listSetup = get(this.processData, 'setup')
      } else {
        const listSetupResponse = await this.getListSetup(this.paramsBase)
        listSetup = get(listSetupResponse, 'body', {})
      }
      const processActionSetup = get(listSetup, 'data.processActions', [])
      this.processActionsButtons = this.resolveProcessButtonOverrides(processActionSetup)
      this.primaryKey = get(listSetup, 'data.primaryKey', null)
      const pkValue = this.primaryKey ? get(this, `$route.query[${this.primaryKey}]`, null) : null
      // Get filters
      const hiddenSearch = this.resolveHiddenSearch(this.hiddenSearchData) || {}
      if (this.hasPredefinedOrder) this.resolveOrderProps()
      const hasFilter = !(
        isEmpty(this.hiddenSearch) ||
        !get(this.hiddenSearch, 'where', []).find((condition) => condition.key === this.primaryKey)
      )
      if (get(this.extendedOptions, 'availableViews.defaultView', '') === 'detailView') {
        this.selectedRow = !this.isCollapsed && !this.detailview ? pkValue : ''
        if (this.primaryKey && !this.detailview && this.selectedRow !== pkValue && !hasFilter) {
          hiddenSearch.where
            ? hiddenSearch.where.push({
                key: listSetup.data.primaryKey,
                value: this.selectedRow,
              })
            : (hiddenSearch.where = [{ key: listSetup.data.primaryKey, value: this.selectedRow }])
        }
      }
      this.hiddenSearch = hiddenSearch
      this.replaceHiddenSearchValues()
      // Set properties to store
      this.properties = Object.assign({}, listSetup.data)
      let columns = get(this.properties, 'columns', [])
      // Update columns with extended options if applicable
      // SqlChosen might not have this.columns at this point
      if (columns && this.columnOverrides) {
        columns = cloneDeep(columns).map((column) => {
          let item = this.columnOverrides.find((option) => {
            return (
              column.data === option.columnName ||
              (column.multiselect === true && column.data === `MULTI_${option.columnName}`)
            )
          })
          if (get(item, 'label')) column.title = item.label
          if (get(item, 'hidden')) column.hidden = !!item.hidden
          return column
        })
        if (!isEmpty(columns)) {
          columns = columns.filter((column) => !column.hidden)
        }
      }
      this.columns = columns
      // Update searchParams with existing searchData
      if (this.searchData) {
        let searchParams = {}
        columns.forEach((column) => {
          const value = get(this.searchData, column.data)
          if (typeof value !== 'undefined') {
            searchParams[column.data] = cloneDeep(value)
          }
        })
        this.searchParams = Object.assign({}, this.searchParams, searchParams)
      }
      // Set available and shown columns for different views
      this.setColumnLists(get(listSetup, 'data', {}))
      // Dynform can emit this event after saving an instance
      this.storeSubscribe = store.subscribe((mutation) => {
        if (mutation.type === 'SET_FORCE_UPDATE') {
          this.$forceUpdate()
        }
      })
    },
    setColumnLists(data) {
      const { showInList, availableInList, availableInDetailView, columns = [] } = data
      const defaultColumnNames = columns.map((column) => column.data)
      this.availableInDetailView = availableInDetailView || defaultColumnNames
      this.availableInList = availableInList || defaultColumnNames
      this.showInList = this.getShowInListFromLocalStore() || showInList || defaultColumnNames
      this.defaultShowInList = this.showInList
    },
    getShowInListFromLocalStore() {
      const storedData = this.localStore?.getItemValue('showInList')
      return storedData?.length > 0 ? storedData : false
    },
    refreshLocalStore() {
      if (this.universalFilter) {
        this.localStore?.setItemValue('universalFilter', this.universalFilter)
      } else {
        this.localStore?.removeItemValue('universalFilter')
      }
      this.localStore?.setItemValue('searchParams', this.searchParams)
    },
    /**
     * @description Inserts searchvalues from given attributes into hiddenSearch container
     */
    replaceHiddenSearchValues() {
      if (!isEmpty(this.hiddenSearch) && this.hiddenSearch.where) {
        const hiddenSearch = cloneDeep(this.hiddenSearch)
        hiddenSearch.where.forEach((data, idx) => {
          if (data.value && data.value[0] === ':') {
            let key = data.value.slice(1)
            if (!isEmpty(this.$attrs[key])) {
              hiddenSearch.where[idx].value = this.$attrs[key]
            } else if (get(this.$CORE, ['params', key])) {
              hiddenSearch.where[idx].value = get(this.$CORE, ['params', key])
            }
          }
        })
        this.hiddenSearch = hiddenSearch
      }
    },
    resetSqlChosen() {
      this.selectedRows = this.value && isArray(this.value) ? this.value : []
      this.$dispatch('setSearchParams', { params: {} })
      this.$dispatch('setUniversalFilter', { value: '' })
    },
    resolveHiddenSearch(hiddenSearchDataProp) {
      if (isEmpty(hiddenSearchDataProp)) return {}

      const hiddenSearch = {}
      if (hiddenSearchDataProp.hasOwnProperty('where')) {
        hiddenSearch.where = cloneDeep(hiddenSearchDataProp.where)
        hiddenSearch.logic = hiddenSearchDataProp.logic
      }

      if (hiddenSearchDataProp.hasOwnProperty('filterExp')) {
        hiddenSearch.filterExp = hiddenSearchDataProp.filterExp
      }

      return hiddenSearch
    },
    /**
     * @description Parses orders from props to orderState
     */
    resolveOrderProps() {
      const orderProps = [
        cloneDeep(this.order),
        cloneDeep(this.orders),
        cloneDeep(get(this.hiddenSearchData, 'order', [])),
      ]
      let orderObj = {}
      orderProps.forEach((props) => {
        props.forEach((order) => {
          if (typeof order === 'string') {
            const [column, value] = order.split(' ')
            if (column) orderObj[column] = value
          }
          if (isObject(order)) {
            const { column, dir: value } = order
            if (column) orderObj[column] = value
          }
        })
      })
      this.$dispatch('setOrder', { value: orderObj })
      if (!this.orderParams.length) {
        this.localStore?.removeItemValue('orderParams')
      } else {
        this.localStore?.setItemValue('orderParams', this.orderParams)
      }
      this.fetchData('order')
    },
    resolveProcessButtonOverrides(processButtons) {
      if (this.extendedOptions.buttons) {
        processButtons.forEach((button) => {
          const processAction = this.extendedOptions.buttons.find(
            (extButton) =>
              extButton.selector === button.processId ||
              extButton.selector === button.selector ||
              (button.url && button.url.match(extButton.selector))
          )
          if (processAction && processAction.name) {
            button.name = processAction.name
          }
        })
      }
      return cloneDeep(processButtons)
    },
    /**
     * @description Resolving expression of a rowStyle
     * @param row
     * @param selector
     * @param operation
     * @param value
     * @returns {boolean}
     */
    resolveRowStyle(row, selector, operation, value) {
      if (!row[selector]) return false
      switch (operation) {
        case '==':
        case '===': {
          return row[selector].toString() === value.toString()
        }
        case '!=':
        case '!==': {
          return row[selector].toString() !== value.toString()
        }
        case '<':
          return row[selector] < value
        case '<=':
          return row[selector] <= value
        case '>=':
          return row[selector] >= value
        case '>':
          return row[selector] > value
      }
    },
    /**
     * @description Resolving rowStyles
     */
    resolveRowStyles() {
      if (isEmpty(this.listData) || isEmpty(this.rowStyle)) {
        return
      }

      const row = { classes: {}, styles: {} }
      const column = { classes: {}, styles: {} }
      const cell = { classes: [], styles: [] }

      this.rowStyle.forEach((rowStyle) => {
        const appliedTo = rowStyle.applied_to ?? ROW_STYLE_ROW

        if (appliedTo === ROW_STYLE_COLUMN) {
          const tableColumns = Object.keys(this.listData[0])
          if (!tableColumns.find((c) => c === rowStyle.selector)) {
            return
          }

          if (rowStyle.class) {
            column.classes[rowStyle.selector] = rowStyle.class
          }
          if (rowStyle.style) {
            column.styles[rowStyle.selector] = convertStringToStyleObject(rowStyle.style)
          }
        } else {
          // ROW or CELL
          const fields = rowStyle.selector.matchAll(ROW_STYLE_MODEL_REGEXP) // eg.: selector: model['FIELD_NAME'] == 'asd', match: ['model["FIELD_NAME', 'model', 'FIELD_NAME', index: 0, input: 'model["FIELD_NAME"]']

          const fieldProps = []
          fields.forEach((field) => {
            fieldProps.push({
              name: field[2], // fieldName from regex match eg.: FIELD_NAME
              reference: field[0], // model fieldName reference eg. model['FIELD_NAME']
            })
          })

          let fieldName = ''
          const results = this.listData.filter((data) => {
            let selector = _.cloneDeep(rowStyle.selector)
            fieldProps.forEach((field) => {
              if (!fieldName) fieldName = field.name
              const value = `${isNumber(data[field.name]) ? data[field.name] : `"${data[field.name]}"`}`
              selector = selector.replaceAll(field.reference, value)
            })
            const condition = new Function(`return ${selector}`)
            return condition()
          })

          if (isEmpty(results)) {
            return
          }

          results.forEach((result) => {
            if (appliedTo === ROW_STYLE_ROW) {
              if (rowStyle.class) {
                row.classes[result[PROP_ROW_KEY]] = rowStyle.class
              }
              if (rowStyle.style) {
                row.styles[result[PROP_ROW_KEY]] = convertStringToStyleObject(rowStyle.style)
              }
            } else if (appliedTo === ROW_STYLE_CELL) {
              const styleObj = {
                field: fieldName,
                rowKey: result[PROP_ROW_KEY],
              }

              if (rowStyle.class) {
                cell.classes.push({
                  ...styleObj,
                  class: rowStyle.class,
                })
              }
              if (rowStyle.style) {
                cell.styles.push({
                  ...styleObj,
                  style: convertStringToStyleObject(rowStyle.style),
                })
              }
            }
          })
        }
      })

      this.$dispatch('setRowClasses', { rowClasses: row.classes })
      this.$dispatch('setRowStyles', { rowStyles: row.styles })

      this.$dispatch('setColumnClasses', { columnClasses: column.classes })
      this.$dispatch('setColumnStyles', { columnStyles: column.styles })

      this.$dispatch('setCellClasses', { cellClasses: cell.classes })
      this.$dispatch('setCellStyles', { cellStyles: cell.styles })
    },
    restoreParameters() {
      const storeContent = this.localStoreContent
      const pager = {
        offset: get(storeContent, 'pager.offset') || get(storeContent, 'searchParams.start') || DEFAULT_PAGER.offset,
        limit: +this.limit || DEFAULT_PAGER.limit,
        total: 0,
      }
      this.pager = get(storeContent, 'pager', pager)
      this.showInList = get(storeContent, 'showInList', this.defaultShowInList)
      this.universalFilter = get(storeContent, 'universalFilter')
      this.viewMode = get(
        storeContent,
        'viewMode',
        get(this.extendedOptions, 'availableViews.defaultView', this.defaultView)
      )
      let storedSearchParams = get(storeContent, 'searchParams', {})
      if (this.infiniteScroll) {
        delete storedSearchParams.start
        delete this.pager.offset
      }
      this.searchParams = storedSearchParams
      const storedAggregations = get(storeContent, 'aggregations')
      if (storedAggregations) {
        this.$dispatch('setAggregations', {
          aggregations: storedAggregations,
        })
      } else {
        this.setDefaultAggregations()
      }
      const storedOrderParams = get(storeContent, 'orderParams')
      if (storedOrderParams) this.orderParams = storedOrderParams
    },
    setDefaultAggregations() {
      this.$dispatch('setAggregations', {
        aggregations: cloneDeep(this.defaultAggregations),
      })
    },
    setViewMode(mode) {
      const visibilityOptions = cloneDeep(this.$get('listVisibilityOptions'))
      const gridOptions = Object.assign({}, visibilityOptions, DEFAULT_LIST_VISIBILITY_OPTIONS)
      const cardOrDetailOptions = Object.assign({}, visibilityOptions, {
        visibleUnselectedRows: true,
      })
      switch (mode) {
        case VIEW_MODE_CARD: {
          this.$dispatch('setListVisibilityOptions', {
            options: cardOrDetailOptions,
          })
          break
        }
        case VIEW_MODE_DETAIL: {
          this.$dispatch('setListVisibilityOptions', {
            options: cardOrDetailOptions,
          })
          break
        }
        case VIEW_MODE_GRID: {
          this.$dispatch('setListVisibilityOptions', { options: gridOptions })
          break
        }
      }
      this.$dispatch('setViewMode', { mode })
      this.localStore?.setItemValue('viewMode', mode)
    },
    /**
     * @description Sets predefined visibility options to the state
     */
    setVisibilityOptions() {
      let options = {}
      for (let key of this.extendedVisibilityProps) {
        options[key] = this.extendedOptions[key]
      }
      if (this.visibleOptions || this.isCollapsed) {
        let visibles = cloneDeep(this.visibleOptions) || {}
        if (this.isCollapsed) {
          visibles = Object.assign(visibles, COLLAPSED_SETTINGS)
        }
        for (let key of Object.keys(visibles)) {
          options[key] = visibles[key]
        }
      }
      this.$dispatch('setListVisibilityOptions', { options })
    },
    resetParams() {
      this.$dispatch('setSelectedRowsFilter', { selectedRowsFilter: 'normal' })
      this.$dispatch('setSearchParams', { params: {} })
      this.$dispatch('setUniversalFilter', { value: '' })
      this.$dispatch('setOrder', { value: cloneDeep(DEFAULT_ORDER) })
      this.$dispatch('setPager', { value: cloneDeep(DEFAULT_PAGER) })
      this.$dispatch('setShowInList', { showInList: this.defaultShowInList })
      this.$dispatch('setAggregations', { aggregations: [] })
      this.deleteFilterParam()
      this.localStore.setStoreContent({})
      if (this.rawSqlNamespace) {
        this.resetBindValues()
        this.$dispatch(`setConditions`, { conditions: [] }, this.rawSqlNamespace)
      }
    },
    initSelectedRowsFilter() {
      if (this.isSqlChosen && this.hasSqlChosenValue) {
        if (this.value.length > this.sqlExpandedLimit) {
          this.isListExpanded = true
        } else {
          this.selectedRowsFilter = 'selected'
        }
        this.selectedRows = Array.isArray(this.value) ? this.value : [this.value]
      }
    },
  },
  created() {
    if (this.customLayout) this.layout = this.customLayout
    this.$dispatch('prepareListStore', {
      uId: this.uniqueId,
      isSqlChosen: this.isSqlChosen ? 'sqlChosen' : 'list',
    })
    EventBus.$on('hidden-file-upload', this.fetchData)
    EventBus.$on(`fetchListData-${this.id}`, (event) => {
      const { parameters = {} } = event
      this.fetchData('default', parameters, true)
    })
  },
  async mounted() {
    await this.createLocalStorage()
    // Set props to the state
    this.fetchingListData = true
    const panelUid = this.$attrs['panelUid']
    const listProps = Object.assign(
      cloneDeep(this.$props),
      { panelUid, listType: this.componentType },
      { ...this.extraOptions }
    )
    if (this.pageSize) this.limit = this.pageSize
    this.$dispatch('setListProps', { props: listProps }).then(() => {
      this.$dispatch('setExtendedOptions', { options: this.extendedOptions })
      this.setVisibilityOptions()
      this.isStoreReady = true
    })

    const parameters = {
      start: get(this.pager, 'offset', 0),
    }

    await this.initCustomList()

    if (this.filterId) parameters.search = await this.getSavedFilter()

    await this.setup()
    this.initSelectedRowsFilter()
    await this.fetchData(null, parameters)

    if (this.mongoId) {
      EventBus.$on(`reset-form-list-${this.mongoId}`, this.applyOrNot)
    }

    EventBus.$on(`apply-filter-${this.id}`, this.applyOrNot)
    EventBus.$on(`reset-order-${this.id}`, this.resetOrder)
    EventBus.$on(`refresh-list-data-${this.id}`, this.refreshListData)
    EventBus.$on(`reset-filter-${this.id}`, (event) => {
      if (this.isSqlChosen) {
        event.type = 'sqlReset'
        this.resetSqlChosen()
        this.applyOrNot(event)
      } else {
        event.type = 'button'
        this.resetParams()
        this.applyOrNot(event)
      }
      if (event.refreshLocalStore) this.refreshLocalStore()
    })
  },

  beforeDestroy() {
    if (this.isSqlChosen) localStorage.removeItem(this.$get('storageKey'), { id: this.uniqueId })

    EventBus.$off('hidden-file-upload')
    EventBus.$off(`apply-filter-${this.id}`)
    EventBus.$off(`reset-filter-${this.id}`)
    EventBus.$off(`reset-order-${this.id}`)
    EventBus.$off(`fetchListData-${this.panelId}`)
    EventBus.$off(`refresh-list-data-${this.id}`)

    if (this.mongoId) {
      EventBus.$off(`reset-form-list-${this.mongoId}`)
    }
  },
  watch: {
    viewMode: {
      handler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
          if (this.needButtonLists) {
            this.fetchButtonLists()
          }
        }
      },
    },
    hiddenSearchData: {
      handler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
          this.$dispatch('setHiddenSearch', newValue)
          this.fetchData()
        }
      },
    },
    mongoList: {
      deep: true,
      handler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
          this.$dispatch('setMongoList', { mongoList: newValue })
        }
      },
    },
    processData: {
      deep: true,
      async handler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
          const { recordsFiltered, recordsTotal, aggregateRow, data, restoreOffset } = this.processData.list
          Object.assign(this, { recordsFiltered, recordsTotal, aggregateRow })

          if (restoreOffset) {
            this.pager = {
              offset: 0,
              limit: +this.limit || DEFAULT_PAGER.limit,
              total: recordsTotal,
            }
          }
          this.listData = data
        }
      },
    },
    sqlChosenButtonProps: {
      deep: true,
      immediate: true,
      handler(newProps, oldProps) {
        if (this.isSqlChosen && !isEqual(newProps, oldProps)) {
          this.$dispatch('setSqlChosenButtonProps', {
            props: {
              ...newProps,
              sqlExpandedLimit: this.sqlExpandedLimit,
            },
          })
        }
      },
    },
    bindValues: {
      deep: true,
      handler: debounce(function (newBinds, oldBinds) {
        if (!isEqual(newBinds, oldBinds)) {
          this.fetchData()
        }
      }, 800),
    },
    conditions: {
      deep: true,
      handler: debounce(function (newConditions, oldConditions) {
        if (!isEqual(newConditions, oldConditions)) {
          this.fetchData()
        }
      }, 800),
    },
    value: {
      handler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
          this.selectedRows = newValue && isArray(newValue) ? newValue : []
          this.fetchData('valueChange', { start: this.offset })
        }
      },
    },
    $route: {
      deep: true,
    },
  },
  render(h) {
    const that = this
    return h({
      name: 'DynamicListContainer',
      mixins: [listCommonMixin, coreMixin],
      components: {
        ConfirmModal,
        SqlChosenControlButtons,
        QueueButtonGroup,
        Limitation,
        ListButtonContainer,
        ListViewContainer,
        Pagination,
        ProgressBar,
        SavedSearchModal,
        SearchButton,
        SearchControl,
        ShowInListModal,
        ListHeaderMenu,
      },
      computed: {
        isReadView() {
          return that.isReadView
        },
        isSqlChosen() {
          return that.$get('isSqlChosen')
        },
        isStoreReady() {
          return that.isStoreReady
        },
      },
      template: `
          <div v-if="isStoreReady">
            ${that.layout}
            <show-in-list-modal />
            <saved-search-modal />
            <confirm-modal />
          </div>
        `,
    })
  },
}
</script>
